import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";
import { toast } from "../../context/TostContext";

const BASE_URL = "/companies/categories";

export const fetchCompanyCategories = createAsyncThunk(
    "companyCategory/fetchList",
    async (params, { rejectWithValue }) => {
        try {
            const { page, limit, search } = params || {};
            const queryParams = new URLSearchParams({
                page: page || 1,
                limit: limit || 10,
                search: search || ""
            });
            const response = await Axios.get(`${BASE_URL}?${queryParams.toString()}`, authHeaders());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const createCompanyCategory = createAsyncThunk(
    "companyCategory/create",
    async (data, { rejectWithValue }) => {
        try {
            const response = await Axios.post(BASE_URL, data, authHeaders());
            toast.success(response.data.message || "Category created successfully");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const updateCompanyCategory = createAsyncThunk(
    "companyCategory/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await Axios.put(`${BASE_URL}/${id}`, data, authHeaders());
            toast.success(response.data.message || "Category updated successfully");
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const toggleCompanyCategoryStatus = createAsyncThunk(
    "companyCategory/toggleStatus",
    async ({ id, is_active }, { rejectWithValue }) => {
        try {
            const response = await Axios.put(`${BASE_URL}/${id}`, { is_active }, authHeaders());
            toast.success(response.data.message || "Status updated successfully");
            return { id, is_active, data: response.data };
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const deleteCompanyCategory = createAsyncThunk(
    "companyCategory/delete",
    async (id, { rejectWithValue }) => {
        try {
            const response = await Axios.delete(`${BASE_URL}/${id}`, authHeaders());
            toast.success(response.data.message || "Category deleted successfully");
            return id;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const companyCategorySlice = createSlice({
    name: "companyCategory",
    initialState: {
        list: [],
        pagination: { total: 0, page: 1, limit: 10 },
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanyCategories.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCompanyCategories.fulfilled, (state, action) => {
                state.isLoading = false;
                state.list = action.payload.data || [];
                state.pagination = action.payload.meta || state.pagination;
            })
            .addCase(fetchCompanyCategories.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteCompanyCategory.fulfilled, (state, action) => {
                state.list = state.list.filter((item) => item.id !== action.payload);
            })
            .addCase(toggleCompanyCategoryStatus.fulfilled, (state, action) => {
                const { id, is_active } = action.payload;
                const category = state.list.find((item) => item.id === id);
                if (category) {
                    category.is_active = is_active;
                }
            });
    },
});

export default companyCategorySlice.reducer;
